import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import classes from "./RegisterZipGame.module.css";
import Header from "../../components/Header";
import ZipGameStepper from "../../components/ZipGameStepper";
import { useLocation, useNavigate } from "react-router-dom";
import { varifyOtpzip } from "../../http/http";

const VerifyZipOtp = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const msisdn = location?.state?.msisdn || "";
  const [otp, setOtp] = useState(["", "", "", ""]);

  useEffect(() => {
    if (!msisdn) {
      navigate("/register/zip-game");
    }
  }, [msisdn, navigate]);

  const handleOtpChange = (index, value) => {
    if (!/^\d?$/.test(value)) return;

    const updatedOtp = [...otp];
    updatedOtp[index] = value;
    setOtp(updatedOtp);

    if (value && index < 3) {
      const nextInput = document.getElementById(`otp-${index + 1}`);
      if (nextInput) nextInput.focus();
    }
  };

  const handleOtpKeyDown = (index, e) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      const prevInput = document.getElementById(`otp-${index - 1}`);
      if (prevInput) prevInput.focus();
    }
  };

  const handleNext = async () => {
    const finalOtp = otp.join("");
    if (finalOtp.length !== 4) return;


    try {
      const r = await varifyOtpzip(msisdn,finalOtp).then(() => {
          navigate("/user-details/zip-game", {
            state: {
              msisdn,
              otp: finalOtp,
            },
          });
        })
        } catch (error) {
          console.log(error)
        }
    }
  

  return (
    <>
      <Header />

      <div className={classes.container}>
        <div className={classes.heroCard}>
          <div className={classes.heroBadge}>{t("173")}</div>
          <h1 className={classes.heroTitle}>{t("190")}</h1>
          <p className={classes.heroText}>
            {t("195")}
          </p>
        </div>

        <ZipGameStepper currentStep={2} />

        <div className={classes.formCard}>
          <div className={classes.section}>
            <div className={classes.sectionHead}>
              <h2 className={classes.sectionTitle}>{t("67")}</h2>
              <p className={classes.sectionText}>
                {t("192")}{msisdn}
              </p>
            </div>

            <div className={classes.otpWrapper}>
              {otp.map((digit, index) => (
                <input
                  key={index}
                  id={`otp-${index}`}
                  type="text"
                  inputMode="numeric"
                  maxLength={1}
                  value={digit}
                  className={classes.otpInput}
                  onChange={(e) => handleOtpChange(index, e.target.value)}
                  onKeyDown={(e) => handleOtpKeyDown(index, e)}
                />
              ))}
            </div>

            <div className={classes.actionRow}>

              <button type="button" className={classes.primaryBtn} onClick={handleNext}>
                {t("190")}
              </button>
              <button
                type="button"
                className={classes.secondaryBtn}
                onClick={() => navigate("/zip-game-register")}
              >
                {t("193")}
              </button>
            </div>

            <button type="button" className={classes.linkBtn}>
              {t("75")}
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default VerifyZipOtp;